const color = '#e4e4e4';

function Footer() {
  return (
    <div className="w-full h-20 flex flex-col flex-center bg-rhino text-sm" style={{ color }}>
      <div className="leading-8">
        Copyright © <span className="text-turquoise">EZtoTrade.</span> All rights Reserved.
      </div>
      <div>EZtoTrade@gmail.com</div>
    </div>
  );
}

export default Footer;
